
import React from "react";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";

interface IProps {
    color: string;
    onChange: (color: string) => void;
}

export default class ColorPicker extends React.Component<IProps, { color: string, displayColorPicker: boolean }> {
    public constructor(props: IProps) {
        super(props);
        this.state = {
            color: props.color || "#fff",
            displayColorPicker: false,
        };
    }

    public render() {
        const styles = reactCSS({
            default: {
                color: {
                    background: this.state.color,
                    borderRadius: "2px",
                    height: "14px",
                    width: "36px",
                },
                cover: {
                    bottom: "0px",
                    left: "0px",
                    position: "fixed",
                    right: "0px",
                    top: "0px",
                },
                popover: {
                    position: "absolute",
                    zIndex: "2",
                },
                swatch: {
                    background: "#fff",
                    borderRadius: "1px",
                    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
                    cursor: "pointer",
                    display: "inline-block",
                    padding: "5px",
                },
            },
        });

        return (
            <div>
                <div style={styles.swatch} onClick={this.handleClick.bind(this)}>
                    <div style={styles.color} />
                </div>
                {this.state.displayColorPicker ? <div style={styles.popover}>
                    <div style={styles.cover} onClick={this.handleClose.bind(this)} />
                    <SketchPicker color={this.state.color} onChange={this.handleChange.bind(this)} />
                </div> : null}
            </div>
        );
    }

    private handleClick() {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    }

    private handleClose() {
        this.setState({ displayColorPicker: false });
    }

    private handleChange(color) {
        this.setState({ color: color.hex }, () => this.props.onChange(this.state.color));
    }
}
